import React from 'react';
import { connect } from 'react-redux';
import { scoreUntilScenarioSelector } from '../services/store';

import Chapter from '../components/Chapter';
import Scenario from '../components/Scenario';
import Text from '../components/Text';
import Box from '../components/Box';
import appen from '../assets/appen.mp4';

const mapStateToProps = (state) => ({
  score: scoreUntilScenarioSelector(3)(state),
});

const Chapter4 = ({
  id,
  trackEvent,
  score,
}) => (
  <Chapter
    id={id}
    media={appen}
    theme="red"
    title="16.00 uur, woensdag"
    onEnter={() => trackEvent(id)}
  >
    <Text>Je krijgt een mail over jouw sollicitatie.</Text>
    {(score < 560) ? (
      <Scenario
        id="4"
        description="Je bent het helaas niet geworden. Je hebt minder dan 560 punten en we zoeken iemand met een hogere score."
        scoreFirst={0}
        scoreSecond={0}
        buttonTextFirst="Shit"
        buttonTextSecond="Balen"
        resultTextFirst="Een slechte score heeft serieuze consequenties. Behalve dat je op de zwarte lijst terecht kan komen, is je score openbaar: dus ook potentiële werkgevers kunnen deze zien."
        resultTextSecond="Een slechte score heeft serieuze consequenties. Behalve dat je op de zwarte lijst terecht kan komen, is je score openbaar: dus ook potentiële werkgevers kunnen deze zien."
        onCallback={(title, choice) => trackEvent(id, choice)}
      />
    ) : (
      <Scenario
        id="4"
        title="Wat doe je?"
        description="Wat leuk dat je hebt gereageerd. We nodigen je graag uit voor een gesprek. Kun je overmorgen?"
        scoreFirst={0}
        scoreSecond={0}
        buttonTextFirst="Ja natuurlijk!"
        buttonTextSecond="Ik kijk er naar uit"
        resultTextFirst="Jouw score is openbaar. Een potentiële werkgever kan jouw score ook zien. En weet zo dus makkelijk of je betrouwbaar bent. Je hebt genoeg punten om uitgenodigd te worden."
        resultTextSecond="Jouw score is openbaar. Een potentiële werkgever kan jouw score ook zien. En weet zo dus makkelijk of je betrouwbaar bent. Je hebt genoeg punten om uitgenodigd te worden."
        onCallback={(title, choice) => trackEvent(id, choice)}
      />
    )}
    <Box>
      <h3>Alibaba weet alles</h3>
      <Text>Alibaba verzorgt niet alleen betaalverkeer, hun apps registreren ook waar je bent. En bovendien heeft het bedrijf kopieën van je belangrijkste documenten, zoals je paspoort en diploma’s. Die gebruik je om je te kunnen aanmelden voor hun diensten.</Text>
      <Text>Alibaba gebruikt sinds kort gezichtsherkenningssoftware. Zo herkennen ze je op camerabeelden in winkels. Handig: zo kun je betalen met een glimlach, zelfs als je je telefoon bent vergeten.</Text>
    </Box>
  </Chapter>
);

export default connect(mapStateToProps)(Chapter4);



// WEBPACK FOOTER //
// ./src/chapters/Chapter4.js